<template>
  <div class="main-event-image-slot">
    <div class="main-event-image">
      <q-img
        :src="mainEventImageInfo.ImageUrl" 
      />
    </div>
    <div class="details">
      <div class="main-event-link">
        <span>{{ mainEventImageInfo.Link }}</span>
      </div>
      <div class="others">
        <div class="actions">
          <q-btn icon="delete" class="buy_btn" @click="deleteConfirmation = true"/>
          <q-btn icon="edit" class="buy_btn" @click="editModal = true"/>
        </div>
      </div>
    </div>

    <q-dialog
      v-model="editModal"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Edit Item</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          You are about to Edit this Event
        </q-card-section>
        
        <q-card-section class="q-pt-none">
          <q-input
            style="margin-top: 8px;"
            v-model="eventDetails.Link"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Link"
            dense
            hint="Link"
          />

          <q-file
            ref="fileRef"
            rounded
            outlined
            v-model="image"
            style="display: none"
            @update:model-value="handleUpload()"
          />

            <div>
              <q-img
                @click="$refs.fileRef.pickFiles()"
                :src="eventDetails.ImageUrl"
                spinner-color="white"
                style="height: 140px; max-width: 150px; cursor: pointer;"
              />
            </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="Update"
            @click="updateImageEvent"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="deleteConfirmation"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Delete Item</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          You are about to Delete {{ eventDetails.Link }}. Are you sure you want to continue?
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="Delete"
            @click="deleteImage"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'MainEventImageList',
  data () {
    return {
      deleteConfirmation: false,
      editModal: false,
      image: null,
      eventDetails: {
        Link: null,
        ImageUrl: null
      }
    }
  },
  watch: {
    editModal (val) {
      if (val) {
        this.eventDetails = cloneDeep(this.mainEventImageInfo)
      }
    }
  },
  methods: {
    ...mapActions({
      requestDeleteEventImage: 'home/requestDeleteEventImage',
      requestUpdateEventImage: 'home/requestUpdateEventImage'
    }),
    async deleteImage () {
      this.$q.loading.show()

      await this.recaptchaLoad('deleteimage')

      await this.requestDeleteEventImage(this.mainEventImageInfo.ID)
        .then(async (response) => {
          await this.recaptchaLoad('deleteimage')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          this.deleteConfirmation = false;

          this.$emit('success-request')

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    },
    async updateImageEvent () {
      this.$q.loading.show()

      await this.recaptchaLoad('updateimage')

      await this.requestUpdateEventImage(this.eventDetails)
      .then(async (response) => {
        await this.recaptchaLoad('updateimage')

        this.$q.notify({
          position: 'top-right',
          message: response.data.message,
          type: 'positive',
        })

        this.editModal = false;

        this.$emit('success-request')

        this.$q.loading.hide()
      })
      .catch((e) => {
        this.$q.notify({
          position: 'top-right',
          message: e.response.data.message,
          type: 'negative',
        })

        this.$q.loading.hide()
      })
    }
  },
  props: {
    mainEventImageInfo: {
      require: true,
      type: Object
    }
  }
}
</script>

<style lang="scss">
.main-event-image-slot {
  display: grid;
  grid-template-columns: .3fr 1fr;
  gap: 16px;
  max-width: 100%;
  margin-top: 16px;

  .main-event-image {
    margin-left: auto;

    .q-img {
      width: 50px;
      height: 50px;
    }
  }

  .details {
    .main-event-link {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2px;

      span {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        white-space: nowrap;
        color: white;
      }
    }  

    .others {
      margin-top: 8px;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 1px;
      color: white;

      .price {
        color: green;
      }

      .actions {
        .buy_btn {
          max-width: 50px;
          margin-right: 8px;
          background-color: #FFC108;
          color: black;
          font-size: 9px;
        }
      }

      .user-name {
        margin-top: 8px;
      }
    }
  }
}
</style>